import dayjs from 'dayjs';
import dayjsLocaleCN from 'dayjs/locale/zh-cn';
import dayjsLocaleEN from 'dayjs/locale/en';
import dayjsLocaleTH from 'dayjs/locale/th';
import dayjsLocaleVI from 'dayjs/locale/vi';
import dayjsLocaleMS from 'dayjs/locale/ms';
import dayjsLocaleTL from 'dayjs/locale/tl-ph';
import dayjsLocaleID from 'dayjs/locale/id';
import dayjsLocaleES from 'dayjs/locale/es';
import dayjsLocaleDE from 'dayjs/locale/de';
import dayjsLocaleJA from 'dayjs/locale/ja';
import dayjsLocaleHK from 'dayjs/locale/zh-hk';
import localeData from 'dayjs/plugin/localeData';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import { i18nInstance } from '../../../common/locale';
dayjs.extend(localeData);
dayjs.extend(customParseFormat);
dayjs.extend(localizedFormat);
dayjs.extend(weekOfYear);
var language = i18nInstance.resolvedLanguage || 'zh-CN';
var locales = {
    en: dayjsLocaleEN,
    'zh-CN': dayjsLocaleCN,
    th: dayjsLocaleTH,
    vi: dayjsLocaleVI,
    ms: dayjsLocaleMS,
    'tl-PH': dayjsLocaleTL,
    'id-ID': dayjsLocaleID,
    'es-MX': dayjsLocaleES,
    de: dayjsLocaleDE,
    ja: dayjsLocaleJA,
    'zh-HK': dayjsLocaleHK,
};
dayjs.locale(language, locales[language]);
export default dayjs;
